import React from 'react'

import { FilterPatchBody, KpiOptionObject } from 'types/GlobalKpiOption'
import { TWidgetSettings } from 'types/GlobalWidget'

import { useBenchmarkAttributeOptions } from 'redux/hooks/AttributeOptions'

import WidgetFilterSection from '../FilterSection'
import { TPatchKpiOptionBody } from 'redux/api/KpiOptions'

interface FilterSectionProps {
  id: string
  kpi: KpiOptionObject
  onClose: () => void
  settings: TWidgetSettings
  showPerFilterOptions: string[]
  updateKpiOption: (body: TPatchKpiOptionBody) => void
}

const FilterSection = (props: FilterSectionProps) => {
  const { id, kpi, onClose, settings, showPerFilterOptions, updateKpiOption } =
    props

  const filterAttributeOptions =
    useBenchmarkAttributeOptions(showPerFilterOptions)

  return (
    // The same filter section is used for both widget and kpi:
    <WidgetFilterSection
      filters={kpi.show_per_filters}
      filterAttributeOptions={filterAttributeOptions}
      id={id}
      onClose={onClose}
      settings={settings}
      updateFilters={(filters: FilterPatchBody[]) => {
        updateKpiOption({ show_per_filters: filters })
      }}
    />
  )
}

export default FilterSection
